export default __webpack_public_path__ + "static/img3@2x-207cfffbf982335b0712977b3efc40b0.jpg";